<mat-icon class="title-icon" [svgIcon]="getPatternImage()"></mat-icon>
